//import Components
import { CSSProperties, useEffect, useState } from "react";
import Loading from "react-loading";

//Component styling

//----------------[Component - PageLoading]---------------------//
//render
type props = {
  containerStyle?: CSSProperties;
  spinnerStyle?: CSSProperties;
  text?: string;
};

export default function ModuleLoading({ text, containerStyle }: props) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 300);
  }, [setShow]);
  if (show) {
    return (
      <div
        className="loading"
        style={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          ...containerStyle,
        }}
      >
        <Loading
          type={"bubbles"}
          color={"#ef6e2d"}
          width={100}
          height={12}
          delay={1}
        />
        {text && (
          <span style={{ marginTop: "3rem" }}>
            <p className={"fs3"}>{text}</p>
          </span>
        )}
      </div>
    );
  } else {
    return null;
  }
}
